import { useEffect, useState } from 'react';
import { Event, nip19 } from 'nostr-tools';
import { getNostrPool } from '../lib/nostrPool';
import { RELAYS } from '../config/constants';
import { useAdmin } from '../contexts/AdminContext';

export const useSingleEvent = (noteIdOrHex: string | undefined) => {
    const [event, setEvent] = useState<Event | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);


    const { settings } = useAdmin();

    useEffect(() => {
        if (!noteIdOrHex) {
            setEvent(null);
            return;
        }

        let hexId = noteIdOrHex;
        if (noteIdOrHex.startsWith('note1')) {
            try {
                const decoded = nip19.decode(noteIdOrHex);
                if (decoded.type === 'note') {
                    hexId = decoded.data;
                }
            } catch (e) {
                console.error('Failed to decode note ID:', e);
                setError('Geçersiz note ID');
                return;
            }
        }

        const pool = getNostrPool();
        setIsLoading(true);
        setError(null);

        const allRelays = [...new Set([...RELAYS, ...settings.customRelays])];

        // Use subscription instead of get for better resilience
        console.log(`[useSingleEvent] Requesting: ${hexId} from relays:`, allRelays.length);

        const sub = pool.subscribeMany(allRelays, {
            ids: [hexId]
        }, {
            onevent(e) {
                console.log(`[useSingleEvent] Found event: ${e.id}`);
                setEvent(e);
                setIsLoading(false);
                sub.close();
            },
            oneose() {
                // Keep open until timeout or event found
            }
        });

        const timeout = setTimeout(() => {
            if (isLoading) {
                console.warn('[useSingleEvent] Timeout reached');
                setIsLoading(false);
                if (!event) setError('Event bulunamadı (Zaman aşımı)');
                sub.close();
            }
        }, 5000);

        return () => {
            sub.close();
            clearTimeout(timeout);
        };
    }, [noteIdOrHex, settings.customRelays]);

    return { event, isLoading, error };
};
